/**
* @file 运营中心-专线工单
* */
<template>
  <div id="vehicleShift">
    <custom-table has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns"
       labelWidth="135">
      <template slot="customTable-top">
        <el-radio-group v-model="status" @change="statusChange" style="padding-bottom: 16px">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button :label="item.value" v-for="item in $const.SHIFTORDERSTATUS2" :key="item.value">
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'schedulingNo'">
          <span class="link" @click="getInfo(row)">{{ row.schedulingNo }}</span>
        </template>
        <template v-else-if="item.prop == 'serviceTime'">{{ row.serviceTime | filterTime }}</template>
        <template v-else-if="item.prop == 'finishTime'">{{ row.finishTime | filterTime }}</template>
        <template v-else-if="item.prop == 'status'">
          <el-tag size="mini" :type="row.status | filterConst('SHIFTORDERSTATUS2', 'type')">{{ row.status | filterConst("SHIFTORDERSTATUS2") }}</el-tag>
        </template>

        <template v-else-if="item.prop == 'startStationName'">
          <div style="display: flex; align-items: center">
            <el-tag effect="plain"
              :type="new Map([[1, 'success'], [2, ''], [3, 'danger'], [null, 'danger']]).get(row.schedulingType)"
              style="margin-right: 8px">
              {{ row.schedulingType | filterConst("DRIVERORDERTYPE", "sort") }}
            </el-tag>
            <div>{{ row.startStationName }} - {{ row.endStationName }}</div>
          </div>
        </template>

        <template v-else-if="item.prop == 'startTimeStamp'">
          {{ row.schedulingTime | filterTime("MM-DD") }}
          {{ row.startLineTime }}
        </template>
        <template v-else-if="item.prop == 'realTotalFee'">
          <span class="util-money" v-if="row.realTotalFee || row.realTotalFee == 0">{{ "¥" + row.realTotalFee }}</span>
          <span v-if="!row.realTotalFee && row.realTotalFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop == 'lineFee'">
          <span class="util-money" v-if="row.lineFee || row.lineFee == 0">
            {{
              row.schedulingType == 3 || row.railType == 2
              ? "¥" + row.lineFee + "起"
              : "¥" + row.lineFee
            }}
          </span>
          <span v-if="!row.lineFee && row.lineFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop == 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>

        <template v-else-if="item.prop === 'occupancyRate'">
          <el-progress v-if="row.occupancyRate != null" :percentage="Number(row.occupancyRate) || 0" :stroke-width="14" :text-inside="true" :color="row.occupancyRate >= 80 ? '#67C23A' : row.occupancyRate >= 50 ? '#E6A23C' : '#F56C6C'" />
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'completionRate'">
          <el-progress v-if="row.completionRate != null" :percentage="Number(row.completionRate) || 0" :stroke-width="14" :text-inside="true" :color="row.completionRate >= 90 ? '#67C23A' : row.completionRate >= 70 ? '#E6A23C' : '#F56C6C'" />
          <span v-else>-</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
    <orderDriverLineDetails :visible.sync="detailsVisible" :order.sync="order" />
  </div>
</template>

<script>
import orderDriverLineDetails from "./orderDriverLineDetails";
export default {
  name: "vehicleShift",
  components: { orderDriverLineDetails },
  data() {
    return {
      // 班次状态
      status: "",
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/order/scheduling",
        // 请求的参数列表
        params: {
          status: this.status,
          page: 1, // 页数
          size: 20, // 每页条数
          orderType: 4
        },
        search: [
          { type: "input", field: "schedulingNo", name: "班次号", value: "" },
          // { type: "input", field: "lineName", name: "线路名称", value: "" },
          { type: "input", field: "startStationName", name: "出发地", value: "" },
          { type: "input", field: "endStationName", name: "目的地", value: "" },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "vehicleNo", name: "车辆编号", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "driverPhone", name: "司机电话", value: "" },
          {
            type: "select",
            field: "serviceOrFinishTimeSort",
            name: "数据排序",
            value: null,
            option: [
              { value: 1, label: "开始时间顺序" },
              { value: 2, label: "开始时间倒序" },
              { value: 3, label: "完成/取消时间顺序" },
              { value: 4, label: "完成/取消时间倒序" },
            ],
          },
          {
            type: "datetime",
            field: "schedulingTime",
            dateProp: {start: "schedulingStartTime", end: "schedulingEndTime"},
            name: "排班时间",
            value: []
          },
          {
            type: "datetime",
            field: "finishTime",
            dateProp: {start: "finishStartTime", end: "finishEndTime"},
            name: "完成/取消时间",
            value: []
          },
        ],
      },
      // 表头
      columns: [
        { prop: "schedulingNo", label: "班次号", width: 120 },
        { prop: "status", label: "班次状态", width: 80 },
        { prop: "lineName", label: "线路", width: 160 },
        { prop: "organizationName", label: "机构名称", width: 120 },
        { prop: "serviceTime", label: "开始时间", width: 130, sortable: true },
        {
          prop: "finishTime",
          label: "完成/取消时间",
          width: 125,
          sortable: true,
        },
        { prop: "startStationName", label: "线路名称", width: 200 },
        { prop: "startTimeStamp", label: "班次", width: 90, sortable: true },
        { prop: "licenseNo", label: "车辆号牌", width: 140 },
        { prop: "vehicleNo", label: "车辆编号", width: 100 },
        { prop: "driverName", label: "司机姓名", width: 100 },
        { prop: "driverPhone", label: "司机电话", width: 120 },
        { prop: "passengerAllNum", label: "乘车人数", width: 80 },
        { prop: "orderCount", label: "订单数", width: 80 },
        { prop: "cancelOrderCount", label: "退票数", width: 80 },
        { prop: "occupancyRate", label: "上座率(%)", width: 100 },
        { prop: "completionRate", label: "完成率(%)", width: 100 },
        { prop: "lineFee", label: "车票价格", width: 110 },
        { prop: "realTotalFee", label: "总计金额", width: 80 },
      ],
      order: {},
      detailsVisible: false,
    };
  },
  methods: {
    /* 状态改变 */
    statusChange() {
      this.customOptions.params.page = 1;
      this.customOptions.params.status = this.status;
      this.$refs.customTable.listFn();
    },
    /* 获取班次详情 */
    async getInfo(row) {
      let url = "/api/v1/manage/order/scheduling/" + row.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.order = data.data || {};
        this.detailsVisible = true;
      }
    },
  },
  created() { },
};
</script>

